import { render, staticRenderFns } from "./GameBoardTimer.vue?vue&type=template&id=35b85b4f&scoped=true&"
import script from "./GameBoardTimer.vue?vue&type=script&lang=js&"
export * from "./GameBoardTimer.vue?vue&type=script&lang=js&"
import style0 from "./GameBoardTimer.vue?vue&type=style&index=0&id=35b85b4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b85b4f",
  null
  
)

export default component.exports